import React, {Component} from 'react';
import {Item, Segment, Label, Button, Icon} from 'semantic-ui-react'
import axios from "axios";
import house from "./house";


class InterestCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            house: props.house,
            email: props.email
        };
        this.onClickHandler = this.onClickHandler.bind(this);
    }


    onClickHandler(){
        const url = `http://node-express-env.yhwg8jeyei.us-west-2.elasticbeanstalk.com/api/houses/${this.state.house._id}`;
        console.log(url);
        axios.delete(url).then((res)=>{
            console.log(res);
            let user = localStorage.getItem('user');
            let profile = JSON.parse(user);
            console.log(profile);
            profile.myInterest = profile.myInterest.filter(e => e !== this.state.house._id);
            console.log(profile);
            user = JSON.stringify(profile);
            localStorage.setItem('user', user);
            window.location = `${process.env.PUBLIC_URL}/users/profile`;
        }).catch((error) => {
            console.log(error);
        });
    }


    render() {
        const house = this.state.house;
        const watcher = [];
        for(let i = 0; i < house.watcher.length; i ++){
            if(house.watcher[i].email !== this.state.email)
                watcher.push(<Label>{house.watcher[i].email}</Label>);
        }
        return (
            <Segment className="interest_card">
                <Item.Group>
                    <Item>
                        <Item.Image className="card_image" src={house.photo[0]} />
                        <Item.Content className="card_container">
                            <Item.Meta content={house.city + "·" + house.state} />
                            <Item.Header>{house.address}</Item.Header>
                            <Item.Description className="card_des">{"\"" + house.description + "\""}</Item.Description>
                            <Item.Extra>
                                <h4>Other interested user:</h4>
                                {watcher}
                            </Item.Extra>
                            <Item.Extra>
                                <Button primary floated='left' onClick={this.onClickHandler}>
                                    No longer interested
                                </Button>
                            </Item.Extra>
                        </Item.Content>
                        <Item.Content className="cost-holder">
                            <Item.Header className="cost">{"$" + house.cost}</Item.Header>
                            <Item.Description className="cost-unit">{"/mon"}</Item.Description>
                        </Item.Content>
                    </Item>
                </Item.Group>
            </Segment>);
    }
}

export default InterestCard;